import React from 'react';
import PrivateRoute from '@shared/routing/PrivateRoute';
import { Switch } from 'react-router';
import './user-management.scss';
import { WorkPlannerPage } from "@features/wall-planner/pages/WorkPlannerPage";
import { WallPlannerNewEventPage } from "@features/wall-planner/pages/WallPlannerNewEventPage";

export default function WallPlannerRouting() {
  return (
    <Switch>
      <PrivateRoute exact path="/work-planner" component={WorkPlannerPage}/>
      <PrivateRoute exact path="/work-planner/event" component={WallPlannerNewEventPage}/>
      <PrivateRoute exact path="/work-planner/event/:eventId" component={WallPlannerNewEventPage}/>
    </Switch>
  )
}
